import { render, staticRenderFns } from "./LpuServicesPagination.vue?vue&type=template&id=ff2b4f4c&"
import script from "./LpuServicesPagination.vue?vue&type=script&lang=js&"
export * from "./LpuServicesPagination.vue?vue&type=script&lang=js&"
import style0 from "./LpuServicesPagination.vue?vue&type=style&index=0&id=ff2b4f4c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2b4f4c')) {
      api.createRecord('ff2b4f4c', component.options)
    } else {
      api.reload('ff2b4f4c', component.options)
    }
    module.hot.accept("./LpuServicesPagination.vue?vue&type=template&id=ff2b4f4c&", function () {
      api.rerender('ff2b4f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuServices/components/LpuServicesPagination.vue"
export default component.exports